import { Checkbox } from '@restomarker/ui-kit';
import type { ReactElement } from 'react';

import { t } from '@/shared/i18n';

import { useSetTelegramAlerts, useTelegramConnection } from './api';
import { TelegramSection } from './TelegramSection';

export interface LegacySectionsProps {
  /** Без сети и в саппорт-сессии. */
  disabled: boolean;
}

/**
 * Прежний сервер (404 на alert-settings — нарушенный порядок выката): только Telegram,
 * как до T-046, — через `/me/telegram/`, с прежней подсказкой-формулой, без порогов.
 *
 * Push здесь нет. У прежнего сервера согласие на push — сама строка телефона, а доставка
 * сессию не смотрит: включённый отсюда push приходил бы на телефон и тому, кто войдёт
 * после (обратная сторона B-039). Живёт, пока сервер не обновят.
 */
export function LegacySections({ disabled }: LegacySectionsProps): ReactElement | null {
  const connection = useTelegramConnection();
  const setAlerts = useSetTelegramAlerts();

  if (!connection.data?.available) return null;
  return (
    <TelegramSection
      showTitle={false}
      disabled={disabled}
      alerts={() => (
        <Checkbox
          checked={connection.data.expiry_alerts ?? false}
          disabled={disabled || setAlerts.isPending}
          onCheckedChange={(next) => setAlerts.mutate(next)}
          label={t('telegram.alerts')}
          hint={t('telegram.alertsHintLegacy')}
        />
      )}
    />
  );
}
